import React, { useState } from 'react';
import { X, Download, Mail } from 'lucide-react';

const EmailGateModal = ({ isOpen, onClose, onSubmit, resourceTitle }) => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    await onSubmit(email);
    setIsSubmitting(false);
    setEmail('');
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} aria-label="Close">
          <X size={24} />
        </button>
        
        <div className="modal-header">
          <div className="modal-icon">
            <Mail size={40} />
          </div>
          <h2 className="heading-2">Access Resource</h2>
          <p className="body-medium modal-subtitle">
            Please provide your email to download this resource
          </p>
        </div>

        <div className="modal-body">
          <div className="resource-info">
            <Download size={20} />
            <span className="body-medium">{resourceTitle}</span>
          </div>

          <form onSubmit={handleSubmit} className="email-gate-form">
            <div className="form-group">
              <label htmlFor="email-gate" className="form-label">
                Email Address *
              </label>
              <input
                type="email"
                id="email-gate"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input"
                placeholder="your.email@company.com"
                required
                autoFocus
              />
            </div>

            <button 
              type="submit" 
              className="btn-primary" 
              style={{ width: '100%' }}
              disabled={isSubmitting}
            >
              <Download size={20} />
              {isSubmitting ? 'Processing...' : 'Download Resource'}
            </button>
          </form>

          <p className="body-small modal-footer-text">
            Your email will only be used to provide you with relevant industry insights and updates.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmailGateModal;
